// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"fa1cbe6f","576":"40d597f4","673":"4536b035","714":"508925f8","787":"d16d0675","989":"9bfb231d"}[chunkId] + ".chunk.js";
};